import React from "react";
import { useTheme } from "@mui/material/styles";
import { Paper, Stack } from "@mui/material";
import Text from "./Text";

interface BadgeProps {
  icon?: React.ReactNode;
  value: string | number;
  variant?: "outlined" | "filled";
  height?: number;
}

const Badge = ({ icon, value, variant = "filled", height }: BadgeProps) => {
  const theme = useTheme();

  const PaperStylesFilled = {
    paddingLeft: "10px",
    paddingRight: "10px",
    paddingTop: height ? 0 : "2px",
    paddingBottom: height ? 0 : "2px",
    display: "flex",
    alignItems: "center",
    backgroundColor: theme.myTheme.colors.gray400,
  };

  const PaperStylesOutlined = {
    paddingLeft: "10px",
    paddingRight: "10px",
    paddingTop: height ? 0 : "2px",
    paddingBottom: height ? 0 : "2px",
    display: "flex",
    alignItems: "center",
    background: "none",
    border: `1px solid ${theme.myTheme.colors.foreground50}`,
  };

  return (
    <Paper
      elevation={0}
      sx={
        variant === "outlined"
          ? { ...PaperStylesOutlined, height: height ? height : "auto" }
          : { ...PaperStylesFilled, height: height ? height : "auto" }
      }
    >
      <Stack direction={"row"} spacing={1} alignItems={"center"}>
        {icon}
        <Text variant="s-semi">{value}</Text>
      </Stack>
    </Paper>
  );
};

export default Badge;
